import { useState, useEffect } from 'react';
import { Box, Typography, Dialog, DialogTitle, DialogContent, useTheme, IconButton, TextField, Hidden, Autocomplete } from '@mui/material';

import SwitchIcon from '@mui/icons-material/CompareArrows';
import { makeStyles } from '@mui/styles';

import { getThongTinHanhSinhDirect, getSwitchUser } from 'store/slices/bqlSystemManageApi';

const useStyles = makeStyles((theme) => ({
    tenantName: {
        marginRight: theme.spacing(2)
    },
    iconLeft: {
        marginRight: theme.spacing(1)
    }
}));

const SwitchUserSection = ({ user }) => {
    const theme = useTheme();
    const classes = useStyles();
    const [rows, setRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [selectedUserName, setSelectedUserName] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const hanhSinhs = await getThongTinHanhSinhDirect();
                if (hanhSinhs && Array.isArray(hanhSinhs)) {
                    setRows(hanhSinhs);
                }
            } catch (error) {
                console.error('Lỗi khi fetch dữ liệu hạnh sinh:', error);
            }
        };

        fetchData();
    }, []);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const handleSwitchUser = async (maHs) => {
        try {
            console.log('Switching to user:', maHs);
            const response = await getSwitchUser(maHs);

            handleClose();
            window.location.href = '/';
        } catch (error) {
            console.error('Switch user failed:', error);
        }
    };
    const isSupport = user?.isSupport === true || user?.isSupport === 'true';

    return (
        <>
            <Box
                sx={{
                    ml: 2,
                    mr: 3,
                    [theme.breakpoints.down('md')]: {
                        mr: 2
                    }
                }}
            >
                <Hidden mdDown>
                    <Box display="flex" alignItems="center">
                        {isSupport && (
                            <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }} onClick={handleOpen}>
                                <IconButton size="small" className={classes.iconLeft}>
                                    <SwitchIcon />
                                </IconButton>
                            </Box>
                        )}
                        <Typography variant="h4" color="secondary" className={classes.tenantName}>
                            {selectedUserName ??
                                (user?.maHs === 'TC01-012' ? 'Đào Anh Tân' : user && (user?.hoTen !== '' ? user?.hoTen : user?.name))}
                        </Typography>
                    </Box>
                </Hidden>
            </Box>

            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle sx={{ fontSize: '1rem' }}>Xem kết quả hạnh sinh</DialogTitle>
                <DialogContent>
                    <Autocomplete
                        options={[{ maHs: 'BQL', fullName: 'Chuyển về BQL' }, { maHs: 'TC01-012', fullName: 'Đào Anh Tân' }, ...rows]}
                        getOptionLabel={(option) => option.fullName}
                        isOptionEqualToValue={(option, value) => option.maHs === value.maHs}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                setSelectedUserName(newValue.maHs === 'BQL' ? null : newValue.fullName);
                                handleSwitchUser(newValue.maHs);
                            }
                        }}
                        renderOption={(props, option) => (
                            <li
                                {...props}
                                key={option.maHs}
                                style={{
                                    fontSize: '1rem',
                                    paddingTop: '12px',
                                    paddingBottom: '12px',
                                    fontWeight: option.maHs === 'BQL' ? 700 : 400,
                                    color: option.maHs === 'BQL' ? 'secondary' : 'inherit'
                                }}
                            >
                                {option.fullName}
                            </li>
                        )}
                        renderInput={(params) => <TextField {...params} label="Chọn hạnh sinh" placeholder="Tìm theo tên hoặc mã" />}
                        sx={{ mt: 2, mb: 4 }}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default SwitchUserSection;
